import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../..';
import { getConfig } from './configAPI';
import { Config } from '../../../model/Config';
import { LoadStatus } from '../../../model';
import { createAppThunk } from '../../thunks';

export interface ConfigState extends Config {
    status: LoadStatus;
}

const initialState: ConfigState = {
    botId: '',
    featureFlags: [],
    groundTeamRatingsConfig: {
        maxQueryPeriodDays: 90
    },
    status: 'idle',
};

export const loadConfig = createAppThunk('config/load', async () => {
    const configResponse = await getConfig();
    return configResponse.data;
});

export const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadConfig.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(loadConfig.fulfilled, (state, action) => {
                state.status = 'idle';
                state.botId = action.payload.botId;
                state.featureFlags = action.payload.featureFlags;
                state.groundTeamRatingsConfig = action.payload.groundTeamRatingsConfig;
            })
            .addCase(loadConfig.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export const selectConfig = (state: RootState) => state.config;

export default configSlice.reducer;
